export const ServiceData1 = {
  title: "CUSTOM SOFTWARE DEVELOPMENT SOLUTIONS",
  description:
    "From enterprise web applications to scalable mobile solutions, we deliver custom software that drives business efficiency and grows with your organization.",
  imageUrl: "./images/software-dev2.png",
  list_title: "OUR DEVELOPMENT SERVICES",
  services: [
    { name: "Custom Web Apps & Enterprise Applications", icon: "/icons/monitor.png"},
    { name: "Custom Mobile Apps and Cross-Platform Solutions", icon: "/icons/mobile.png"},
    { name: "API Development & System Integration", icon: "/icons/cloud-add.png"},
  ],
  howWeWorkSteps: [
    {
      number: "01",
      title: "DISCOVERY",
      description: "We analyze your business requirements and develop comprehensive project roadmaps aligned with your objectives and industry best practices.",
    },
    {
      number: "02",
      title: "DESIGN",
      description: "We create intuitive user experiences and engaging interfaces following modern design principles and accessibility standards.",
    },
    {
      number: "03",
      title: "DEVELOPMENT",
      description: "We build scalable solutions using agile methodology, ensuring quality through continuous testing and iteration.",
    },
    {
      number: "04",
      title: "LAUNCH AND SUPPORT",
      description: "We provide seamless deployment, comprehensive training, and 24/7 technical support to ensure long-term success.",
    },
  ],
};

export const ServiceData2 = {
  title: "ENTERPRISE CYBERSECURITY SOLUTIONS",
  description:
    "Protect your business with advanced threat detection and enterprise-grade security solutions.",
  imageUrl: "/images/cyber-img.png",
  list_title: "OUR CYBERSECURITY SERVICES",
  services: [
    { name: "Data Protection & Advanced Encryption", icon: "/icons/shield-tick.png"},
    { name: "Network Security & Threat Monitoring", icon: "/icons/lock.png" },
    { name: "Cyber Risk Assessment & Compliance Management", icon: "/icons/radar.png" },
  ],
  howWeWorkSteps: [
    { number: "01", title: "AUDIT", description: "We conduct comprehensive vulnerability assessments and security audits to identify potential risks in your systems." },
    {
      number: "02",
      title: "SECURE",
      description: "We implement enterprise-grade security measures and advanced protection protocols to fortify your infrastructure.",
    },
    {
      number: "03",
      title: "MONITOR",
      description: "We provide 24/7 threat monitoring and real-time security surveillance to detect suspicious activities.",
    },
    {
      number: "04",
      title: "RESPOND",
      description: "We deliver rapid incident response and breach prevention through automated security protocols and expert intervention.",
    },
  ],
};

export const ServiceData3 = {
  title: "ENTERPRISE IT SOLUTIONS",
  description:
    "Transforming businesses with scalable enterprise IT infrastructure, secure cloud solutions, and intelligent automation platforms that optimize operations and drive digital transformation.",
  imageUrl: "/images/enterprise-img.png",
  list_title: "OUR ENTERPRISE SERVICES",
  services: [
    { name: "Cloud Solutions & Migration", icon: "/icons/cloud-connection.png" },
    { name: "Scalable IT Infrastructure & Management", icon: "/icons/driver.png" },
    { name: "Intelligent Business Process Automation", icon: "/icons/briefcase.png" },
  ],
  howWeWorkSteps: [
    {
      number: "01",
      title: "CONSULT",
      description: "We analyze enterprise workflows and assess infrastructure requirements for optimal efficiency.",
    },
    {
      number: "02",
      title: "BUILD",
      description: "We implement custom enterprise solutions and cloud-based infrastructure integration.",
    },
    { number: "03", title: "TRAIN", description: "We deliver comprehensive team training and knowledge transfer for seamless adoption." },
    {
      number: "04",
      title: "OPTIMIZE",
      description: "We ensure peak system performance through continuous monitoring and optimization.",
    },
  ],
};

export const ServiceData4 = {
  title: "IT PROCUREMENT AND INSTALLATIONS",
  description:
    "From enterprise hardware sourcing to professional deployment, we deliver end-to-end IT infrastructure solutions with expert installation and configuration.",
  imageUrl: "/images/procurement-service.png",
  list_title: "OUR DEPLOYMENT SERVICES",
  services: [
    {
      name: "Hardware and Software Procurement",
      icon: "/icons/monitor-mobbile.png",
    },
    { name: "Professional IT Equipment Installation", icon: "/icons/setting-2.png" },
    { name: "Advanced System Configuration & Integration", icon: "/icons/setting-5.png" },
  ],
  howWeWorkSteps: [
    {
      number: "01",
      title: "RECOMMEND",
      description: "We provide expert IT infrastructure recommendations based on your business requirements.",
    },
    {
      number: "02",
      title: "PURCHASE",
      description: "We procure enterprise-grade hardware and software solutions through authorized channels.",
    },
    { number: "03", title: "INSTALL", description: "We deliver professional deployment and system integration services." },
    {
      number: "04",
      title: "SUPPORT",
      description: "We maintain 24/7 technical support and proactive system maintenance.",
    },
  ],
};

export const ServiceData5 = {
  title: "TECHNICAL SUPPORT",
  description:
    "Your business deserves enterprise-grade IT support that never sleeps. Our expert team provides round-the-clock technical assistance to ensure your systems perform optimally.",
  imageUrl: "/images/tech-support.png",
  list_title: "OUR TECHNICAL SUPPORT",
  services: [
    { name: "24/7 IT support & Help Desk", icon: "/icons/music-play.png" },
    { name: "Advanced Troubleshooting and Resolution", icon: "/icons/search-normal.png" },
    { name: "Proactive System maintenance and maintenance", icon: "/icons/setting-2.png" },
  ],
  howWeWorkSteps: [
    {
      number: "01",
      title: "DIAGNOSE",
      description: "We perform comprehensive system analysis to identify root causes.",
    },
    { number: "02", title: "FIX", description: "We implement rapid solutions with minimal business disruption." },
    {
      number: "03",
      title: "PREVENT",
      description: "We establish proactive monitoring and maintenance protocols.",
    },
  ],
};

export const ServiceData6 = {
  title: "OUR CONSULTING SERVICES",
  description:
    "We develop strategic technology solutions that drive business growth, optimize IT infrastructure, and ensure sustainable digital transformation.",
  imageUrl: "/images/technology-consult.png",
  list_title: "OUR TECHNOLOGY CONSULTING SERVICE",
  services: [
    { name: "Enterprse Digital Strategy Development", icon: "/icons/cpu-charge.png" },
    { name: "Advanced IT Cost Optimization", icon: "/icons/receipt-item.png" },
    { name: "Tailored Tech Training & Workshops", icon: "/icons/teacher.png" },
  ],
  howWeWorkSteps: [
    { number: "01", title: "ANALYZE", description: "We conduct comprehensive business technology assessments." },
    { number: "02", title: "PLAN", description: "We develop strategic digital transformation roadmaps." },
    {
      number: "03",
      title: "IMPLEMENT",
      description: "We execute precision-driven technology solutions.",
    },
    {
      number: "04",
      title: "OPTIMIZE",
      description: "We ensure continuous performance enhancement.",
    },
  ],
};
